import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("srinidhi_admin_token");
  if (token && config.url && config.url.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem("srinidhi_admin_token");
      if (
        window.location.pathname.startsWith("/admin") &&
        window.location.pathname !== "/admin/login"
      ) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export const api = {
  settings: () => client.get("/chat/settings").then((r) => r.data),
  startSession: () => client.post("/chat/session").then((r) => r.data),
  sendMessage: (session_id, message) =>
    client.post("/chat/message", { session_id, message }).then((r) => r.data),
  createAppointment: (payload) =>
    client.post("/appointments", payload).then((r) => r.data),
  submitHandoff: (payload) =>
    client.post("/handoff", payload).then((r) => r.data),
  // admin
  adminLogin: (email, password) =>
    client.post("/admin/login", { email, password }).then((r) => r.data),
  adminMe: () => client.get("/admin/me").then((r) => r.data),
  listConversations: (params) =>
    client.get("/admin/conversations", { params }).then((r) => r.data),
  getConversation: (session_id) =>
    client.get(`/admin/conversations/${session_id}`).then((r) => r.data),
  listAppointments: (params) =>
    client.get("/admin/appointments", { params }).then((r) => r.data),
  updateAppointmentStatus: (id, status) =>
    client.patch(`/admin/appointments/${id}`, { status }).then((r) => r.data),
  listHandoffs: () => client.get("/admin/handoffs").then((r) => r.data),
  analytics: () => client.get("/admin/analytics").then((r) => r.data),
  getKB: () => client.get("/admin/kb").then((r) => r.data),
  updateKB: (content) => client.put("/admin/kb", { content }).then((r) => r.data),
};

export function saveAdminToken(t) {
  localStorage.setItem("srinidhi_admin_token", t);
}
export function clearAdminToken() {
  localStorage.removeItem("srinidhi_admin_token");
}
export function hasAdminToken() {
  return !!localStorage.getItem("srinidhi_admin_token");
}

export default api;
